import { normalizeProductionSheetProfile, type ProductionSheetProfile } from './production-sheet-profile';

/** Exact option binding, never a first-template or same-size fallback. */
export function resolveProductionSheetProfile(
  specifications: Record<string, unknown> | undefined,
  configuration: Record<string, string | number>,
): ProductionSheetProfile | null {
  const variants = specifications?.productionSheetProfiles;
  if (variants === undefined) return normalizeProductionSheetProfile(specifications?.productionSheetProfile);
  if (!Array.isArray(variants) || !variants.length || variants.length > 64) throw new Error('Invalid production sheet variants');
  if (specifications?.productionSheetProfile != null) throw new Error('Ambiguous production sheet configuration');
  const matches: ProductionSheetProfile[] = [];
  for (const row of variants) {
    if (!row || typeof row !== 'object' || !row.match || typeof row.match !== 'object' || Array.isArray(row.match)) throw new Error('Invalid production sheet match');
    const entries = Object.entries(row.match);
    if (!entries.length || entries.length > 12 || entries.some(([key, value]) => !/^[a-zA-Z0-9_-]{1,80}$/.test(key) || typeof value !== 'string' || !value || value.length > 160)) throw new Error('Invalid production sheet match');
    const profile = normalizeProductionSheetProfile(row.productionSheetProfile);
    if (!profile) throw new Error('Missing production sheet profile');
    if (entries.every(([key, value]) => Object.hasOwn(configuration, key) && String(configuration[key]) === value)) matches.push(profile);
  }
  if (matches.length > 1) throw new Error('Ambiguous production sheet selection');
  return matches[0] || null;
}
